import React from 'react';

type WeatherFormat = '' | '1' | '2' | '3' | '4' | 'v2' | string;

type WeatherEmbedProps = {
    city: string;
    format?: WeatherFormat;
    height?: number | string;
    className?: string;
};

const Weather = ({
    city,
    format = '',
    height = 320,
    className,
}: WeatherEmbedProps) => {
    const base = `https://wttr.in/${encodeURIComponent(city)}`;
    const src = format ? `${base}?format=${format}` : base;

    return (
        <iframe
            src={src}
            title={`Weather for ${city}`}
            width="100%"
            height={height}
            className={className}
            style={{
                border: 'none',
                width: '100%',
                colorScheme: 'dark',
                background: 'black',
            }}
            loading="lazy"
        />
    );
};

export default Weather;